import React from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd';
import { vrLinkLabel } from '~constants/gallery';
import { fileStatusCondition } from '~helpers/pending-approval';
import SingleLink from '~pages/pms-dashboard/properties/listing-management/gallery-management/virtual-tour-links/virtual-tour-link/single-link';

export default class VirtualTourLink extends React.PureComponent {
  render() {
    const { t, links, form, section, rooms, statusFilter } = this.props;

    return (
      <div className="virtual-tour-link">
        <Choose>
          <When
            condition={links.filter(file => fileStatusCondition(file, statusFilter)).length > 0}
          >
            <div className="virtual-tour-link-header">
              <div className="virtual-tour-link-header__column" />
              <div className="virtual-tour-link-header__column">
                <span className="virtual-tour-link-title">
                  {t('cms:cms.properties.edit.gallery.virtual_tour.link_address')}
                </span>
              </div>
              <If condition={section === vrLinkLabel.PROPERTY}>
                <div className="virtual-tour-link-header__column">
                  <span className="virtual-tour-link-title">
                    {t('cms:cms.properties.edit.gallery.virtual_tour.area_of_property')}
                  </span>
                </div>
              </If>
              <If condition={section === vrLinkLabel.ROOM}>
                <div className="virtual-tour-link-header__column">
                  <span className="virtual-tour-link-title">
                    {t('cms:cms.properties.edit.gallery.virtual_tour.room')}
                  </span>
                </div>
              </If>
            </div>
            <div className="virtual-tour-link-header__links-wrap">
              <For
                of={links.filter(file => fileStatusCondition(file, statusFilter))}
                each="virtualTourLinkItem"
              >
                <SingleLink
                  key={virtualTourLinkItem.id}
                  t={t}
                  virtualTourLinkItem={virtualTourLinkItem}
                  onDeleteLink={this.props.onDeleteLink}
                  section={section}
                  rooms={rooms}
                  form={form}
                  links={links}
                  onSetSelectedRooms={this.props.onSetSelectedRooms}
                />
              </For>
            </div>
          </When>
          <Otherwise>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </Otherwise>
        </Choose>
        <div
          className="btn__add-another-link"
          onClick={() => {
            this.props.onAddAnOtherLink(section);
          }}
          role="presentation"
        >
          {t('cms:cms.properties.edit.address.add_another_link')}
        </div>
      </div>
    );
  }
}

VirtualTourLink.propTypes = {
  t: PropTypes.func,
  onAddAnOtherLink: PropTypes.func,
  onDeleteLink: PropTypes.func,
  onSetSelectedRooms: PropTypes.func,
  links: PropTypes.array,
  rooms: PropTypes.array,
  form: PropTypes.object,
  section: PropTypes.string,
  statusFilter: PropTypes.oneOf([
    'all_content',
    'draft',
    'pending_approval',
    'published',
    'rejected',
  ]),
};

VirtualTourLink.defaultProps = {
  t: () => {},
  onAddAnOtherLink: () => {},
  onDeleteLink: () => {},
  onSetSelectedRooms: () => {},
  links: [],
  rooms: [],
  form: {},
  section: vrLinkLabel.PROPERTY,
  statusFilter: 'all_content',
};
